import { PageHeader as AntPageHeader } from 'antd';
import styled from 'styled-components';

const PageHeader = styled(AntPageHeader)`
  position: sticky;
  top: 0;
  z-index: 1;
  align-items: center;
  margin-bottom: 1.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

export default { PageHeader };
